export const GLOBAL_HOME_NAV_ITEM_ID = 'global-home';